import React, { Component } from 'react';
import EasyTable from '../EasyTable';

class PMAssignedTable extends Component {
	state = {
		currentItem: null,
	}

	componentDidMount() {
		this.retrieveAndFilter();
	}

	componentDidUpdate(prevProps) {
		if (prevProps !== this.props) {
			this.retrieveAndFilter();
		}
	}

	retrieveAndFilter = () => {
		const p = this.props;
		this.setState({
			currentItem: p.users[p.currentUserIndex]
		})
	}

	render() {
		const p = this.props;
		// filter projects that belong to this user
		let filtered = [];
		if (p.currentUserIndex !== -1) {
			filtered = p.assignments.filter(this.isAssignedToUser);
		}

		return (
			<div className={"PMAssignedTable"} >
				<EasyTable
					tableName={"Your Assigned Projects"}
					selectValue={'parentID'}
					headers={['BP', 'Project', 'Staff']}
					show={['bp', 'display', 'assigned']}
					data={filtered}
					onClick={p.selectBP}
					customColumns={['assigned']}
					renderCustomColumn={this.renderCustomColumn}
				>
				</EasyTable>
			</div>
		);
	}

	renderCustomColumn = (property, row, i) => {
		switch (property) {
			case 'assigned':
				let usernames = [];
				row[property].forEach(element => {
					let loc = this.props.users.findIndex(indexOfUser)
					if (loc > -1) {
						usernames.push(this.props.users[loc].firstName + ' ' + this.props.users[loc].lastName.substring(0, 1))
					}
					function indexOfUser(usr) {
						return usr.uniqueID === element;
					}
				});
				return <td key={i}>{usernames.join(", ")}</td>
			default:
				return <td key={i}>{row[property]}</td>
		}
	}

	isAssignedToUser = (pj) => {
		let result = false;
		if (pj.assigned !== null && this.state.currentItem !== null && pj.assigned.includes(this.state.currentItem.uniqueID)) {
			result = true;
		}
		return result;
	}

}
export default PMAssignedTable;


// WEBPACK FOOTER //
// ./src/components/projectmanager/new/PMAssignedTable.js